import { IonAvatar } from '@ionic/react';
import React from 'react';
import { Character } from '../../models';

interface Props {
  className?: string;
  user: Character | null;
  isOnline?: boolean;
}

export const CharacterAvatar = ({ className, user, isOnline }: Props) => (
  <IonAvatar
    className={`${className ? className + ' ' : ''}${isOnline ? 'online' : ''}`}
  >
    {user !== null && user.avatarUrl ? (
      <img src={user.avatarUrl} alt="" />
    ) : (
      <img src="/assets/img/anonymous.jpg" alt="" />
    )}
  </IonAvatar>
);
